module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-04.44f50bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-04.jpg
// module id = cZjt
// module chunks = 51